import React, { Component, PropTypes } from 'react';
import {
  RefreshIndicator,
  Dialog,
  FlatButton,
  TextField,
  IconButton,
  Checkbox,
  FontIcon,
} from 'material-ui';
import LogIn from '../integration-tourplan-login';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import CheckedCircleIcon from 'material-ui/svg-icons/action/check-circle';
import Select from 'react-select';
import R, { merge, slice } from 'ramda';
const propTypes = {
  productId: PropTypes.string,
  tourPlanOptionID: PropTypes.string,
  tourPlanOptionName: PropTypes.string,
  exportTo: PropTypes.string,
  rateSetStatus: PropTypes.string,
  validateMappingStatus: PropTypes.string,
  index: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  checkIfHasRates: PropTypes.func,
  validateMapping: PropTypes.func,
  updateMapping: PropTypes.func,
  dispatch: PropTypes.func,
  hasRates: PropTypes.bool,
  productName: PropTypes.string,
  user: PropTypes.object,
  integration: PropTypes.object,
  contract: PropTypes.object,
  ratePackageName: PropTypes.string,
  priceCodes: PropTypes.array,
  savePriceCodesSettings: PropTypes.func,
  checkOnePackage: PropTypes.func,
  checked: PropTypes.bool,
  hasPrivateTransfers: PropTypes.bool,
};
// REWRITE THIS WHOLE THING WHEN POSSIBLE
class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: props.productId,
      disableTF: Boolean(props.tourPlanOptionID),
      tpName: props.tourPlanOptionName ? props.tourPlanOptionName : undefined,
      validateStatus: props.tourPlanOptionName ? 'ready' : (props.validateMappingStatus || undefined),
      doNotCheckRates: false,
      dialogLogin: false,
    };
  }
  componentDidMount() {
    const { index, tourPlanOptionID, startDate, endDate, contract } = this.props;
    if (tourPlanOptionID && !R.has('hasRates', this.props)) {
      const contractWithSingleProductMapping = merge(contract, { products: slice(index, index + 1, contract.products) });
      this.props.checkIfHasRates(index, tourPlanOptionID, startDate, endDate, contractWithSingleProductMapping);
    }
  }

  componentWillReceiveProps(nextProps) {
    const validateMappingStatus = nextProps.validateMappingStatus;
    const tourPlanOptionName = nextProps.tourPlanOptionName;
    const validateError = nextProps.validateError;
    let errorText;
    if (validateError === '404' || validateError === '400' || validateError === 'Not Found') {
      errorText = 'ID is invalid.';
    } else if (validateError === '401') {
      this.setState({ dialogOpen: true });
      errorText = 'Authentication Error';
    } else if (validateError) {
      errorText = 'Server error: please try again later or contact our customer service';
    }

    this.setState({
      disableTF: Boolean(nextProps.tourPlanOptionID),
      validateStatus: tourPlanOptionName ? 'ready' : (validateMappingStatus || undefined),
      tpName: tourPlanOptionName,
      errorText,
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  onChangePriceCodes = e => {
    const {
      savePriceCodesSettings,
    } = this.props;
    const codes = e.target.value.split(',');
    savePriceCodesSettings(codes);
  };

  onUpdateExportTo = option => {
    const { index, contract, updateMapping } = this.props;
    updateMapping(index, {
      contractWithProductToUpdate: {
        ...contract,
        products: [{
          ...contract.products[index],
          exportTo: option.value,
        }],
      },
    }, { exportTo: option.value });
  };

  onUpdateRateSetStatus = option => {
    const { index, contract, updateMapping } = this.props;
    updateMapping(index, {
      contractWithProductToUpdate: {
        ...contract,
        products: [{
          ...contract.products[index],
          rateSetStatus: option.value,
        }],
      },
    }, { rateSetStatus: option.value });
  };

  _handleOnBlur = e => {
    this._validate(e.target.value);
  };

  _handleOnChange = e => {
    if (e.target.value.length > 15) {
      this._validate(e.target.value);
    }
  };

  _validate = value => {
    const { index, startDate, endDate, contract, productId } = this.props;
    const tpID = value.trim().toUpperCase();
    const contractWithSingleProductMapping = merge(contract, { products: slice(index, index + 1, contract.products) });
    this.props.validateMapping(index, tpID, startDate, endDate, contractWithSingleProductMapping, productId);
  };
  _edit = () => {
    this.setState({ disableTF: false });
  };

  _dialogLoginHide = () => {
    this.refs.dialogLogin.dismiss();
    this.setState({ errorText: '' });
  };

  render() {
    const productHintText = 'Option ID';
    const indicator = (() => {
      if (this.props.validateMappingStatus === 'validating') {
        return <RefreshIndicator size={30} top={0} left={0} status="loading" style={{ position: 'none' }} />;
      } else if (this.props.validateMappingStatus === 'ready' && this.props.tourPlanOptionID) {
        if (this.props.hasRates) return <WarningIcon color="rgba(0, 0, 0, 0.54)"/>;
        return (<CheckedCircleIcon color="#00bcd4" />);
      } else if (this.props.validateMappingStatus === 'failed') {
        return <RefreshIndicator percentage={60} size={30} top={0} left={0} status="ready" style={{ position: 'none' }} />;
      }
    })();
    return (
      <div style={{ width: '100%', paddingLeft: '3%', justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '32px' }}>
          <Checkbox
            disabled={!Boolean(this.props.tourPlanOptionID)}
            checked={this.props.checked}
            onCheck={this.props.checkOnePackage}
          />
        </div>
        <div style={{ width: 'calc(50% - 282px)', fontSize: '14px' }} className="flex-center">
          {this.props.productName} {this.props.ratePackageName ? ` - ${this.props.ratePackageName}` : ''}
          {
            this.props.hasPrivateTransfers && (
              <FontIcon className="tc-icon-bulb" color="orange" style={{ fontSize: '20px' }} />
            )
          }
        </div>
        <div style={{ width: '250px', display: 'flex', alignItems: 'center' }}>
          <TextField
            style={{ width: '80%', minWidth: '200px' }}
            ref={this.state.productId}
            errorText={this.state.errorText}
            id={this.state.productId}
            defaultValue={this.props.tourPlanOptionID || ''}
            onBlur={this._handleOnBlur.bind(this)}
            onChange={this._handleOnChange.bind(this)}
            hintText={productHintText}
            disabled={this.state.disableTF}
          />
          <IconButton
            iconClassName={ this.state.disableTF ? 'tc-icon-mode_edit' : '' }
            iconStyle={{ color: '#E5625C', fontSize: '14px' }}
            style={{ width: '36px', height: '36px' }}
            onClick={this._edit.bind(this)}
            tooltip="Edit"
          />
        </div>
        <div style={{
          width: 'calc(50% - 420px)',
          display: 'flex',
          alignItems: 'center',
          color: this.props.hasRates ? 'grey' : '#00bcd4',
        }}
        >
          {indicator}
          <div style={{ marginLeft: '8px' }}>{this.state.tpName}</div>
        </div>
        <div style={{ width: '140px' }}>
          <Select
            name="rateStatus"
            style={{ width: '80%' }}
            options={[{ value: 'K', label: 'Confirmed' }, { value: 'P', label: 'Provisional' }]}
            value={this.props.rateSetStatus}
            onChange={this.onUpdateRateSetStatus}
            defaultValue="K"
            clearable={false}
          />
        </div>
        <div style={{ width: '140px' }}>
          <Select
            name="exportTo"
            style={{ width: '80%' }}
            options={[
              { value: 'FIT', label: 'FIT' },
              { value: 'Group', label: 'Group' },
              { value: 'FIT & Group', label: 'FIT & Group' },
            ]}
            value={this.props.exportTo}
            onChange={this.onUpdateExportTo}
            defaultValue="FIT"
            clearable={false}
          />
        </div>
        <div
          style={{ fontSize: '14px', color: 'rgb(54%, 54%, 54%)', width: '140px' }}
        >

          <input
            id={`${this.state.productId}priceCodes`}
            style={{ width: '120px' }}
            placeholder="Based on settings"
            defaultValue={this.props.priceCodes ? this.props.priceCodes.join(',') : ''}
            onChange={this.onChangePriceCodes}
          />
          {
            Boolean(this.props.priceCodes && this.props.priceCodes && !/^[a-zA-Z0-9,]*$/.test(this.props.priceCodes.join(',')))
            && (
              <div style={{ color: '#ff4081' }}>
                <small>Please separate price codes using commas only.</small>
              </div>
            )
          }
        </div>
        <Dialog
          open={this.state.dialogLogin}
          ref="dialogLogin"
          actions={[
            <FlatButton
              label="Dismiss"
              key="dialogLoginDismiss"
              secondary
              disableTouchRipple
              onClick={this._dialogLoginHide.bind(this)}
            />,
          ]}
          modal
        >
          <LogIn {...this.props} transition={this._dialogLoginHide.bind(this)} type="validate"/>
        </Dialog>
      </div>
    );
  }
}

Product.propTypes = propTypes;

export default Product;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/product-mapping-product.jsx